module.exports = __webpack_public_path__ + "img/mobile-27.f90e739d.png";